module.exports = __webpack_public_path__ + "static/media/Galih.cda31782.png";